import generateGuid from "./generate-guid";
import { CachedBooleanValue, CachedItem, sessionStorage, storage } from "./cached-item";
import RequestHelper from "./request-helper";
import UrlBuilder from "./url-builder";
import UrlUtils from "./url-utils";
import disableConsole from "./disable-console";
import removeEmptyEntries from "./remove-empty-entries";
import { isRequired, isRequiredNumber, isRequiredNumberString } from "./form-lib";

declare global {
    interface String {
        toTitleCase(): string;
        toLowerUnderscoreCase(): string;
    }
};

require("./lower-underscore-case");
require("./title-case");

export {
    disableConsole,
    generateGuid,
	isRequired,
    isRequiredNumber,
    isRequiredNumberString,
    removeEmptyEntries,
    storage,
    sessionStorage,
    CachedItem,
    CachedBooleanValue,
    RequestHelper,
    UrlBuilder,
    UrlUtils
}